import type { PlanAssumptions, PlanRecurrentPayment } from '@/api/generated/model';

export function resolveRecurrentPayments(assumptions: PlanAssumptions): PlanRecurrentPayment[] {
  if (assumptions.recurrentPayments?.length) {
    return assumptions.recurrentPayments;
  }
  return [
    {
      id: 'default-salary',
      name: 'Annual salary',
      type: 'income',
      amount: assumptions.currentW2Income ?? 0,
      frequency: 'annual',
      growthRate: assumptions.incomeAnnualGrowthRate ?? 0,
    },
    {
      id: 'default-living',
      name: 'Living expenses',
      type: 'expense',
      amount: (assumptions.monthlyLivingExpenses ?? 0) * 12,
      frequency: 'annual',
      growthRate: assumptions.expensesAnnualGrowthRate ?? 0,
    },
  ];
}

export function annualAmountForYear(payment: PlanRecurrentPayment, yearIndex: number): number {
  const amount = payment.amount ?? 0;
  const growthRate = payment.growthRate ?? 0;
  const base = payment.frequency === 'monthly' ? amount * 12 : amount;
  return base * Math.pow(1 + growthRate, yearIndex);
}

export function sumAnnualIncomeFromRecurrentPayments(
  assumptions: PlanAssumptions,
  yearIndex = 0
): number {
  return resolveRecurrentPayments(assumptions)
    .filter((p) => p.type === 'income')
    .reduce((sum, p) => sum + annualAmountForYear(p, yearIndex), 0);
}

export function sumRecurrentForYear(
  payments: PlanRecurrentPayment[],
  yearIndex: number
): { income: number; expenses: number } {
  let income = 0;
  let expenses = 0;
  for (const payment of payments) {
    const amount = annualAmountForYear(payment, yearIndex);
    if (payment.type === 'income') {
      income += amount;
    } else {
      expenses += amount;
    }
  }
  return { income, expenses };
}
